export default __webpack_public_path__ + "static/media/about-part-1.8548988a.png";